// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MassInquiryPage--wrapper","venueCellsWrapper":"MassInquiryPage--venueCellsWrapper","successWrapper":"MassInquiryPage--successWrapper"};